import React from 'react';
import { Box, Button, Typography } from '@material-ui/core';

import { RsvpBadge } from '../../Attendance/rsvp-badge.component';
import { getRsvpReasonText, getRsvpResponderText } from '../../Attendance/attendance.helpers';
import { formatSessionDateTime, formatSessionPlace } from '../../../lib/helpers/assessment-session.helpers';
import { PlayerPageCard } from './player-page-card.component';

interface ISessionRowProps {
  session: IPlayerAttendanceSession;
  onSelect: (assessmentSessionId: string) => void;
}

// One ice time rendered as its own nested card inside the outer "Upcoming ice
// times" card. The RSVP control only renders when the coach requested attendance.
export const SessionRow: React.FC<ISessionRowProps> = ({ session, onSelect }) => {
  const place = formatSessionPlace(session);
  const hasResponse = session.status !== 'pending';
  const reasonText = getRsvpReasonText(session);
  const responderText = getRsvpResponderText(session);

  return (
    <PlayerPageCard nested>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="flex-start"
        style={{ gap: '0.75rem' }}
      >
        <Box>
          <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
            {formatSessionDateTime(session.date, session.start)}
          </Typography>
          {place && (
            <Typography variant="body2" color="textSecondary">{place}</Typography>
          )}
          {session.address && (
            <Typography variant="body2" color="textSecondary">{session.address}</Typography>
          )}
        </Box>
        {session.isAttendanceRequested && (
          <Box
            display="flex"
            flexDirection="column"
            alignItems="flex-end"
            style={{ gap: '0.5rem', flexShrink: 0 }}
          >
            <Box
              style={{
                background: '#f9fafb',
                border: '1px solid #e5e7eb',
                borderRadius: 8,
                padding: '8px 12px',
                textAlign: 'right',
              }}
            >
              <RsvpBadge status={session.status} />
              {reasonText && (
                <Typography variant="caption" color="textSecondary" display="block">{reasonText}</Typography>
              )}
              {responderText && (
                <Typography variant="caption" color="textSecondary" display="block">{responderText}</Typography>
              )}
            </Box>
            <Button
              variant="contained"
              size="small"
              onClick={() => onSelect(session.assessmentSessionId)}
              style={{ background: '#3b82f6', color: '#ffffff' }}
            >
              {hasResponse ? 'Edit RSVP' : 'RSVP'}
            </Button>
          </Box>
        )}
      </Box>

      {!session.isAttendanceRequested && (
        <Typography variant="body2" color="textSecondary" style={{ marginTop: 12 }}>
          No RSVP requested for this ice time.
        </Typography>
      )}
    </PlayerPageCard>
  );
};
